import { gql } from "@apollo/client";

export const LIST_ADDRESSES_COMPANY = gql`
  query listAddresses($filter: AddressFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listAddresses(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        addressType {
          label
          value
        }
        addressNr
        city
        country {
          name
          code
        }
        postalCode
        addressBtq
        address3
        address2
        address1
      }
    }
  }
`;

export const DELETE_ADDRESS = gql`
  mutation deleteClientAddress($id: ID!) {
    deleteClientAddress(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;
